
export type ConfirmDeletePortfolioFolderModalType = 'folder';

class ConfirmDeletePortfolioFolderModalController {
    
    private close:Function; //injected from modal-service
    private closeCallback:Function;
    
    public deleteAction: string = 'delete';
    public title: string;
    public baseObjectId: string;
    public type: ConfirmDeletePortfolioFolderModalType;
    public folderType: 'portfolio';
	
	// @ngInject
	constructor(
		public $timeout : ng.ITimeoutService,
		public ModalService	
	){}
	
	public onConfirmDelete = () => {
	    this.closeModal(true);
	}
	
    private closeModal = (confirmDelete = false) =>{
		if(this.closeCallback != null){
			this.closeCallback()(confirmDelete);
		}
		
		if(this.close != null){
			this.close();
		}
		
		this.ModalService.closeModals();
    }
    
}

class ConfirmDeletePortfolioFolderModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    title: "<",
	    baseObjectId: "<",
	    deleteAction: "<?",
	    type: "<",
	    folderType: "<?",
	    close:'&?',
		closeCallback:'&',
	};

	public controller = ConfirmDeletePortfolioFolderModalController;
	public controllerAs = 'confirmDeletePortfolioFolderModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/confirm-delete-portfolio-folder-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ConfirmDeletePortfolioFolderModal };
